import { render, staticRenderFns } from "./LatestReview.vue?vue&type=template&id=f274e8e4&scoped=true&"
import script from "./LatestReview.vue?vue&type=script&lang=js&"
export * from "./LatestReview.vue?vue&type=script&lang=js&"
import style0 from "./LatestReview.vue?vue&type=style&index=0&id=f274e8e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f274e8e4",
  null
  
)

export default component.exports